import { TabStyles } from '@tableau/widgets';

import { TabpanelScrollContainerTestIdSuffix } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { cssClass } from '../../style';

export namespace AuthorizableTypeSelectorStyles {
  const AuthorizableTypeSelectorCssPrefix = 'AuthorizableTypeSelector';

  export const titleMarginBottom = 18;
  export const tabsHeight = 36;
  export const tabsBottomHeight = 3;
  export const tabsMarginTop = 20;
  export const tabsMarginBottom = 20;

  export const Container = cssClass(AuthorizableTypeSelectorCssPrefix, 'container', {
    display: 'flex',
    width: '100%',
    paddingTop: `${tabsMarginTop}px`,
  });

  export const TabsBottom = cssClass(AuthorizableTypeSelectorCssPrefix, 'tabs-bottom', {
    height: tabsBottomHeight, // Matches the height of the bottom bar of the TabsWidget
    backgroundColor: TabStyles.Colors.L3,
    width: '100%',
    position: 'relative',
    top: '35px', // TabsWidget height is 36 px, however each tab panel adds a bottom border of 1px. There is no way to override
    // tabs style and we need to show this bottom grey line right below the underline line thus 36px-1px (border) = 35px
  });

  export const TabsContainer = cssClass(AuthorizableTypeSelectorCssPrefix, 'tabs-container', {
    // marginBottom: '20px',
    // marginLeft: `${PermissionsGridStyles.GranteeCellWidth}px`,
    // marginTop: `${titleMarginBottom}px`,
    flex: 1,
    $nest: {
      [`& [data-tb-test-id$="${TabpanelScrollContainerTestIdSuffix}"]`]: {
        padding: '0px !important',
      },
      '& [role="tablist"]': {
        height: `${tabsHeight}px !important`,
        // width: `790px`,
      },
    },
    // display: 'flex',
  });

  export const TabsOverflowButton = cssClass(AuthorizableTypeSelectorCssPrefix, 'overflow-button', {
    // TFSID 1372812: Currently there is no widget to handle "tabs overflow", so this is a short term solution from UX.
    // Clicking on the final tab opens a dropdown menu under the tab. To position this dropdown, a DropdownButton
    // has to be located next to the tab (and be the same height as the tab as well as have some width).
    // However the DropdownButton itself should be effectively invisible - so this CSS removes all colors and makes it not-tabbable.
    $nest: {
      ':hover': {
        boxShadow: 'unset !important',
        backgroundColor: 'unset !important',
        cursor: 'unset',
      },
      ':focus': {
        boxShadow: 'unset !important',
        backgroundColor: 'unset !important',
        cursor: 'unset',
      },
      'button': {
        cursor: 'initial !important',
        height: `${tabsHeight}px`,
        margin: 'auto',
        width: `${1}px`,
        $nest: {
          ':hover': {
            boxShadow: 'none',
            backgroundColor: 'none',
            cursor: 'initial',
          },
        },
      },
      '& [role="presentation"]': {
        display: 'none',
      },
    },
  });
}

